export const displayStatusLabel = (
  defaultName: string,
  customLabel?: string | null
): string => {
  return customLabel ?? defaultName;
};

export interface StatusWithLabel {
  name: string;
  customLabel?: string | null;
}

export const buildStatusLabelResolver = (
  statuses: StatusWithLabel[]
): ((name: string) => string) => {
  const labelByName: Map<string, string | null> = new Map(
    statuses.map((status: StatusWithLabel) => [
      status.name,
      status.customLabel ?? null,
    ])
  );

  return (name: string): string => {
    return displayStatusLabel(name, labelByName.get(name));
  };
};
